import { render, staticRenderFns } from "./u-tooltip-outlined-tile.vue?vue&type=template&id=b79d71e6&scoped=true&"
import script from "./u-tooltip-outlined-tile.vue?vue&type=script&lang=js&"
export * from "./u-tooltip-outlined-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79d71e6",
  null
  
)

export default component.exports